import { LitElement, html } from 'lit';
import styles from './studio-progress.css.mjs';

export class StudioProgress extends LitElement {
  static styles = styles;

  static properties = {
    position: { type: String, reflect: true },
    state: { type: String, reflect: true },
    percent: { type: Number, reflect: true },
    color: { type: String, reflect: true },
  };

  static validPositions = ['left', 'right'];
  static validStates = ['active', 'disabled'];

  constructor() {
    super();
    this.position = 'left';
    this.state = 'active';
    this.percent = 0;
    this.color = '';
  }

  set position(value) {
    const newValue = StudioProgress.validPositions.includes(value) ? value : 'left';
    if (this._position !== newValue) {
      this._position = newValue;
      console.debug(`StudioProgress: position changed to ${newValue}`);
      this.requestUpdate('position');
      // Log DOM order after next render
      this.updateComplete.then(() => {
        const wrapper = this.renderRoot.querySelector('.progress-wrapper');
        const children = wrapper ? Array.from(wrapper.children).map(c => c.className) : [];
        console.debug(`StudioProgress: DOM order: ${children.join(', ')}`);
      });
    }
  }

  get position() {
    return this._position;
  }

  set state(value) {
    this._state = StudioProgress.validStates.includes(value) ? value : 'active';
  }

  get state() {
    return this._state;
  }

  set percent(value) {
    const num = Number(value);
    this._percent = isFinite(num) ? Math.max(0, Math.min(100, Math.floor(num))) : 0;
  }

  get percent() {
    return this._percent;
  }

  set color(value) {
    this._color = typeof value === 'string' ? value : '';
  }

  get color() {
    return this._color;
  }

  render() {
    const percentText = `${this.percent}%`;
    return html`
      <div
        class="progress-wrapper"
        role="progressbar"
        aria-valuenow="${this.percent}"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label="Progress ${percentText}"
        data-position="${this.position}"
        style="${this.color ? `--progress-fill-bg: ${this.color}` : ''}"
      >
        ${this.position === 'left'
          ? html`
              <slot name="label" class="label-slot">
                <span class="label">${percentText}</span>
              </slot>
              <div class="progress-bar">
                <div class="fill" style="width: ${this.percent}%"></div>
              </div>
            `
          : html`
              <div class="progress-bar">
                <div class="fill" style="width: ${this.percent}%"></div>
              </div>
              <slot name="label" class="label-slot">
                <span class="label">${percentText}</span>
              </slot>
            `}
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('studio-progress', StudioProgress);